import SignupWizard from "components/Signup/SignupWizard";
import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";

function Signup() {
  const { account, currently_selected_organization } = useContext(
    OrgRolesAndAccountContext
  );
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (account && !currently_selected_organization) {
      setStep(2);
    }
    if (account && currently_selected_organization) {
      setStep(3);
    }
  }, [account, currently_selected_organization]);

  return (
    <div className="flex flex-col items-center justify-center h-[70vh]">
      <Helmet>
        <title>Sign Up</title>
      </Helmet>

      <SignupWizard step={step} setStep={setStep} />
    </div>
  );
}

export default Signup;
